<template>
<!-- 您的芝麻分是多少？ -->
  <div class="txzl-wrap" >
    <p>*您的信息仅展示给银行或持牌平台，未经您授权我们不会泄露您的信息*</p>
    <div class="txzl-wrap-title">
      <span>您的职业是？</span>
      <span></span>
    </div>
    <div>
      <van-radio-group v-model="vocation" @change="goNext">
        <van-cell-group :border="false"> 
          <van-cell v-for="(items, index) in vocationData" :key="index" :title="items.text" :border="false" checked-color="#0294FF" @click="checkVlue(items.text)" clickable>
            <template #right-icon>
              <van-radio :name="items.text_value" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="btn-fixed" @click="goNext">
      <div class="loanbtn">
        <div :style="{width: loanBtnWidth+'%'}"></div>
        <p>下一步({{loanNumber}}/{{infoData.param_total}})</p>
      </div>
    </div>
  </div>
</template>
<script>
import { CellGroup, Cell, Radio, RadioGroup, Button, Toast } from 'vant'
// import { mapState } from 'vuex'
export default {
  name: 'Zhimafen',
  data() {
    const vocation = JSON.parse(window.localStorage.getItem('loanParams')).vocation
    const infoData = JSON.parse(window.localStorage.getItem('infoData'))
    return {
      vocation: !!vocation ? vocation : '',
      showZmScore: false,
      vocationData: infoData.result.vocation.options,
      channel_lable: window.localStorage.getItem('channel'),
      loanNumber: Number(this.$route.query.loanNumber),
      loanBtnWidth: 0,
      infoData: infoData
    }
  },
  created() {
    // console.log(this.infoData)
    this.loanBtnWidth = ((this.loanNumber-1)/Number(this.infoData.param_total))*100
  },
  methods: {
    checkVlue(value) {
      this.vocation = value
    },
    goNext() {
      if(!!this.vocation) {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        });
        let loanParams = window.localStorage.getItem('loanParams') ? JSON.parse(window.localStorage.getItem('loanParams')) : {}
        loanParams['vocation'] = this.vocation
        window.localStorage.setItem('loanParams', JSON.stringify(loanParams))
        const loanNumber = this.loanNumber + 1
        this.$router.push('/loan/components/xyked?channel_lable='+ this.channel_lable+'&loanNumber='+ loanNumber)
      }else {
        this.$toast('请选择')
      }
    }
  },
  components: {
    [Cell.name]: Cell,
    [Radio.name]: Radio,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button
  }
}
</script>